import get from 'lodash/get';
import API from '@/api';

const types = {
  SET_CONVERSATIONS: 'SET_CONVERSATIONS',
};

const state = {
  conversations: [],
};

const getters = {};

const mutations = {
  [types.SET_CONVERSATIONS](state, conversations) {
    // eslint-disable-next-line no-param-reassign
    state.conversations = conversations;
  },
};

const actions = {
  async getMyConversations({ commit }) {
    const response = await API.conversation.getMyConversations();
    commit(types.SET_CONVERSATIONS, response.data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
